import { useEffect, useState } from "react";

export type Theme = "light" | "dark";

export function useTheme() {
  const [theme, setThemeState] = useState<Theme>(() => {
    if (typeof window !== "undefined") {
      return (localStorage.getItem("theme") as Theme) || "light";
    }
    return "light";
  });

  const setTheme = (nextTheme: Theme) => {
    setThemeState(nextTheme);
    if (typeof window === "undefined") return;

    localStorage.setItem("theme", nextTheme);
    if (nextTheme === "light") {
      document.documentElement.classList.remove("dark");
      document.documentElement.classList.add("light");
    } else {
      document.documentElement.classList.remove("light");
      document.documentElement.classList.add("dark");
    }
    window.dispatchEvent(new Event("boide-theme-change"));
  };

  useEffect(() => {
    if (typeof window === "undefined") return;
    const syncTheme = () => {
      setThemeState(document.documentElement.classList.contains("dark") ? "dark" : "light");
    };
    syncTheme();
    window.addEventListener("boide-theme-change", syncTheme);
    return () => {
      window.removeEventListener("boide-theme-change", syncTheme);
    };
  }, []);

  return { theme, setTheme };
}
